<template>
  <div class="page page-login p-d-flex p-jc-center p-ai-center">
    <Card>
      <template #header>

      </template>
      <template #title>
        Log In
      </template>
      <template #content>
        <login-form @logged-in="onLoggedIn"/>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from 'primevue/card'
import LoginForm from '../auth/LoginForm.vue'
export default {
  name: 'LoginPage',
  components: {
    LoginForm,
    Card
  },
  methods: {
    onLoggedIn () {
      this.$router.push({name: 'screen'})
    }
  }
}
</script>

<style>
.page-login {
  min-height: 100vh;
  background:url('/static/img/bg.jpg');
}
.p-card {
  background: rgba(0,0,0,0.4);
}
.p-card-body {
  background: none;
}
.p-card-title, .formulate-input-label {
  color: white;
}
.formulate-input-error {
  color: #c63c3c !important;
  background-color: rgba(0,0,0,0.5);
  font-weight: 700 !important;
  padding: 0.2rem;
}
.formulate-input-element--submit {
  text-align: center;
}
.page-login input[type="text"], input[type="password"] {
  background: rgba(255,255,255,0.05) !important;
  color: white !important;
}
.formulate-input-element--submit button {
  min-width: 160px !important;
  text-align: center !important;
  background-color: #030b30 !important;
  border-color: #222 !important;
}
.formulate-input-element--submit button span {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LoginPage.vue